import { GraphQlRequestService } from '../../../api/graphql-request-service';
import { Granularity } from '../../common/components/timeslider/types';
import { Domains } from '../../constants';
import { getMomentDate } from '../../date/date-utils';
import { DataTypes } from '../../types';
import { Hasher } from '../hasher';
import { HasDependencies, hashString, Role } from '../types';
import { TimePoint } from './types';

export interface TimeRangesService extends HasDependencies {
  getTimeRanges: () => Promise<Partial<Record<DataTypes, TimePoint[]>> | null>;
}

export class BackendTimeRangesService implements TimeRangesService {
  constructor(
    readonly graphQlRequestService: GraphQlRequestService,
    readonly domain: Domains,
    readonly simulateRole: Role | null
  ) {}

  public getDeps = () => [
    hashString([
      ...this.graphQlRequestService.getDeps(),
      this.domain,
      Hasher.hash(this.simulateRole),
    ]),
  ];

  getTimeRanges = async (): Promise<Partial<
    Record<DataTypes, TimePoint[]>
  > | null> => {
    const result =
      await this.graphQlRequestService.graphQlSdk.availableDataVersions({
        domain: this.domain,
        simulateRole: this.simulateRole?.id ?? null,
      });
    return result.availableDataVersions
      ? Object.fromEntries(
          result.availableDataVersions.map((adr) => {
            const sortedTimePoints = [...adr.timePoints].sort(
              (a, b) =>
                getMomentDate(a.calendarMonth).valueOf() -
                getMomentDate(b.calendarMonth).valueOf()
            );
            const timePoints = sortedTimePoints.map((tp) => {
              return {
                [Granularity.MONTH]: getMomentDate(tp.calendarMonth).toDate(),
                [Granularity.YEAR]: tp.calendarYear,
                [Granularity.FINYEAR]: tp.financialYear,
                [Granularity.FINQUARTER]: tp.financialQuarter,
              };
            });
            return [adr.dataType, timePoints];
          })
        )
      : null;
  };
}
